import React from 'react';
import { PatternFormat } from 'react-number-format';
import { TextMaskCustomProps } from './types';

export const CPFTextMaskCustom = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;

  return <PatternFormat {...other} getInputRef={inputRef} format="###.###.###-##" />;
};

export const CNPJTextMaskCustom = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;

  return <PatternFormat {...other} getInputRef={inputRef} format="##.###.###/####-##" />;
};

export const DDDTextMaskCustom = (props: TextMaskCustomProps) => {
  const { inputRef, ...other } = props;

  return <PatternFormat {...other} getInputRef={inputRef} format="##" />;
};

export const PhoneTextMaskCustom = (props: TextMaskCustomProps) => {
  const { inputRef, value, ...other } = props;
  const numericValue = value.replace(/[ -]/g, '');
  const format = numericValue.length === 8 ? '####-#####' : '#####-####';

  return <PatternFormat {...other} value={value} getInputRef={inputRef} format={format} />;
};
